export function axios_interceptor() {
  axios.interceptors.request.use(
    function(config) {
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      if (error.response.status === 401) {
        console.log("Error 401");
        localStorage.removeItem("frontend-jwt-token");
        location.reload();
      }
      // return Promise.reject(error);
      return error.response;
    }
  );
}
